import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { MissingTranslationHandler, TranslateCompiler, TranslateLoader, TranslateModule, TranslateService, TranslateStore } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { CustomMissingTranslationHandler } from '../i18n/custom-missing-translation-handler';
//import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { IsAdmin } from '../directive/is-admin';
import { MaterialModule } from '../material.module';
import { CustomDecimalPipe } from '../pipes/custom-decimal.pipe';
import { TypeNamePipe } from '../pipes/types-pipe';

import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';

// icons
import { TablerIconsModule } from 'angular-tabler-icons';
import * as TablerIcons from 'angular-tabler-icons/icons';


import { DragDropModule } from '@angular/cdk/drag-drop';
import { registerLocaleData } from '@angular/common';
import localeJa from '@angular/common/locales/ja';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { DataViewModule } from 'primeng/dataview';
import { DialogModule } from 'primeng/dialog';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { TableModule } from 'primeng/table';
import { DetailViewItemComponent } from '../component/detail-view-item.component';
import { FormErrorMessagesComponent } from '../component/form-error-message.component';
import { MessageDialogComponent } from '../component/message-dialog.component';
import { NavItemService } from '../layouts/full/sidebar/sidebar-data';
import { SafeUrlPipe } from '../pipes/safe-url.pipe';
import { HttpCacheService } from '../services/http-cache-service';
// import { NgxChartsModule } from '@swimlane/ngx-charts';
import { HelpPopupComponent } from '../component/help-popup/help-popup.component';
import { EnvironmentTranslateLoader } from '../i18n/environment-translate-loader';

import { Injectable } from "@angular/core";
import { MissingTranslationHandlerParams } from '@ngx-translate/core';
import { EnvironmentTranslateCompiler } from '../i18n/environment-translate-compiler';
import { ApiKeyTableComponent } from '../component/apikey-table/apikey-table.component';
import { ApiKeyRegistDialog } from '../component/apikey-table/regist-dialog/apikey-regist-dialog';
import { ApiKeyDisplayDialog } from '../component/apikey-table/apikey-display-dialog/apikey-display-dialog';
import { LanguageSelectorComponent } from '../component/language-selector.component';
import { GenericTableComponent } from '../component/generic-table/generic-table.component';
import { MarkdownModule } from 'ngx-markdown';


export function HttpLoaderFactory(http: HttpClient) {
    // return new EnvironmentTranslateLoader(http);
    return new TranslateHttpLoader(http);
}


registerLocaleData(localeJa, 'ja-JP');

@NgModule({
    declarations: [
        // 共有されるコンポーネント、ディレクティブ、パイプをここで宣言します。
        IsAdmin,
        TypeNamePipe,
        CustomDecimalPipe,
        MessageDialogComponent,
        DetailViewItemComponent,
        FormErrorMessagesComponent,
        SafeUrlPipe,
        HelpPopupComponent,
        ApiKeyTableComponent,
        ApiKeyRegistDialog,
        ApiKeyDisplayDialog,
        LanguageSelectorComponent,
        GenericTableComponent,
    ],
    imports: [
        CommonModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            },
            missingTranslationHandler: {
                provide: MissingTranslationHandler,
                useClass: CustomMissingTranslationHandler,
            },
            compiler: {
                provide: TranslateCompiler,
                useClass: EnvironmentTranslateCompiler
            },
            isolate: true,
        }),
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        TablerIconsModule.pick(TablerIcons),
        MatNativeDateModule,
        TableModule,
        DynamicDialogModule,
        DialogModule,
        MatIconModule,
        DataViewModule,
        MatMomentDateModule,
        MessagesModule,
        MaterialModule,
        DragDropModule,
        RouterModule,
        MarkdownModule.forRoot(),
    ],
    providers: [TranslateStore, HttpCacheService, DatePipe, CurrencyPipe, NavItemService,
        { provide: LOCALE_ID, useValue: 'ja-JP' },

        { provide: MAT_DATE_LOCALE, useValue: 'ja-JP' },

        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },

    ],
    exports: [
        TablerIconsModule,
        CommonModule,
        TranslateModule,
        MessagesModule,
        MatMomentDateModule,
        IsAdmin,
        TypeNamePipe,
        MaterialModule,
        CustomDecimalPipe,
        MessageDialogComponent,
        MaterialModule,
        MatIconModule,
        DialogModule,
        DynamicDialogModule,
        TableModule,
        DetailViewItemComponent,
        FormErrorMessagesComponent,
        SafeUrlPipe,
        HelpPopupComponent,
        ApiKeyTableComponent,
        ApiKeyRegistDialog,
        ApiKeyDisplayDialog,
        LanguageSelectorComponent,
        GenericTableComponent,
        MarkdownModule,
    ]
})
export class SharedModule {

    constructor(private translate: TranslateService) {
        this.translate.addLangs(['en', 'ja']);
        this.translate.setDefaultLang('en');
        const browserLang = this.translate.getBrowserLang();
        this.translate.use(browserLang?.match(/en|ja/) ? browserLang : 'en');

        window.addEventListener('languagechange', (a) => {
            this.translate.use(navigator.language);
        });
    }

}
